export const baseCanonical = "https://cryptopool.dev";
